import { LatLng, Marker as MarkerEntity } from 'leaflet';
import React, { useEffect, useImperativeHandle, useRef, useState } from 'react';
import { Marker, MarkerProps, useMap, useMapEvents } from 'react-leaflet';
import { createDeviceMarkerIcon } from './DeviceMarkerIcon';

export const MarkerMapControl = React.forwardRef<
  MarkerEntity,
  Partial<
    MarkerProps & {
      onClickMap: (e: { latlng: LatLng }) => boolean;
      position?: LatLng;
      allowUseEffect?: boolean;
      hideIcon?: boolean;
    }
  >
>(({ onClickMap, allowUseEffect = true, hideIcon = false, ...props }, ref) => {
  const e = useRef<MarkerEntity>({} as MarkerEntity);
  const map = useMap();

  const [markerPos, setMarkerPos] = useState<LatLng>(props.position || map.getCenter());

  useEffect(() => {
    if (!props.position) return;

    setMarkerPos(props.position);
    map.setView(props.position, map.getZoom());
  }, [map, props.position?.lat, props.position?.lng]);

  useMapEvents({
    click: (e) => {
      let isClickable = false;

      if (onClickMap) isClickable = onClickMap(e);

      isClickable && setMarkerPos(e.latlng);

      return false;
    },
  });

  allowUseEffect &&
    useEffect(() => {
      if (onClickMap && e.current) onClickMap({ latlng: markerPos });
    }, []);

  useImperativeHandle(ref, () => e.current);

  return markerPos && !hideIcon ? (
    <Marker
      {...props}
      position={markerPos}
      ref={e}
      icon={props.icon || createDeviceMarkerIcon(false, false)}
    />
  ) : (
    <></>
  );
});
